// extracted by mini-css-extract-plugin
export default {"banner":"Home_banner__VtwCY","conteiner":"Home_conteiner__UAXuh","sub_content":"Home_sub_content__SIwuW","cards":"Home_cards__FRr8F","card":"Home_card__tR+82"};